import React, { useEffect, useState } from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';
import {injectIntl} from '@s7ui-kit/s7ui-kit';
import VideoBanner from '../VideoBanner/VideoBanner';
import '../../../assets/styles/components/sale-banner.scss';

const mapStateToProps = ({App}) => ({App});

const SaleBanner = props => {
    const { finish, blurImage, focusImage, title, bgColor, textColor, updateTime, videoBannerDesktop, videoBannerMobile, videoDesktopLink, videoMobileLink, videoBannerDesktopOverlay, videoBannerMobileOverlay, isFirstMount } = props;
    const { words, getMessage } = props;

    const finishTimestamp = Date.parse(finish);
    let nowTimestamp = new Date().getTime();
    const period = finishTimestamp - nowTimestamp;

    const [time, setTime] = useState(period);
    const [blurImgIsLoad, setBlurImgIsLoad] = useState(false);
    const [focusImgIsLoad, setFocusImgIsLoad] = useState(false);

    const timeout = () => {
        setTimeout(() => {
            setTime(period);
        }, 1000);
    };

    const declination = (n, text) => {
        n = Math.abs(n) % 100;
        const n1 = n % 10;

        if (n > 10 && n < 20) {
            return text[2];
        }

        if (n1 > 1 && n1 < 5) {
            return text[1];
        }

        if (n1 === 1) {
            return text[0];
        }

        return text[2];
    };

    useEffect(() => {
        timeout();
    });

    // const currentTime = {
    //     getTime () {
    //         let seconds = Math.floor(time / 1000);
    //         let minutes = Math.floor(seconds / 60);
    //         seconds = seconds % 60;
    //
    //         let hours = Math.floor(minutes / 60);
    //         minutes = minutes % 60;
    //         let days = Math.floor(hours / 24);
    //         hours = hours % 24;
    //
    //         days = (days >= 10) ? days : "0" + days;
    //         hours = (hours >= 10) ? hours : "0" + hours;
    //         minutes = (minutes >= 10) ? minutes : "0" + minutes;
    //         seconds = (seconds >= 10) ? seconds : "0" + seconds;
    //
    //         return { days, hours, minutes, seconds }
    //     },
    //     getDays () {
    //         const { days } = this.getTime();
    //         return days;
    //     },
    //     getHours() {
    //         const { hours } = this.getTime();
    //         return hours;
    //     },
    //     getMinutes() {
    //         const { minutes } = this.getTime();
    //         return minutes;
    //     },
    //     getSeconds() {
    //         const { seconds } = this.getTime();
    //         return seconds;
    //     }
    // };
    const fixNumber = number => number >= 10 ? number : `0${number}`;

    const currentTime = {
        getDays () {
            if(new Date(time).getUTCDate() <= 10) {
                return `0${new Date(time).getUTCDate() - 1}`
            } else {
                return new Date(time).getUTCDate() - 1;
            }

        },
        getHours() {
            return fixNumber(new Date(time).getUTCHours());
        },
        getMinutes() {
            return fixNumber(new Date(time).getUTCMinutes());
        },
        getSeconds() {
            return fixNumber(new Date(time).getUTCSeconds());
        }
    };

    const renderContent = () => {
        return(
            <div className="sale-banner-content">
                {
                    time > 0 ? <div className="sale-banner-time"
                            style={{
                                color: textColor
                            }}
                        >
                        <div className="sale-banner-time-item">
                            <div
                                className="sale-banner-time__day"
                            >
                                { currentTime.getDays() }
                            </div>
                            <span className="sale-banner-time-unit">
                                { getMessage(words, 'com.s7.sale.banner.timer.day') }
                            </span>
                        </div>
                        <div className="sale-banner-time-item">
                            <div
                                className="sale-banner-time__hour"
                            >
                                { currentTime.getHours() }
                            </div>
                            <span className="sale-banner-time-unit">
                                { getMessage(words, 'com.s7.sale.banner.timer.hour') }
                            </span>
                        </div>
                        <div className="sale-banner-time-item">
                            <div
                                className="sale-banner-time__minute"
                            >
                                { currentTime.getMinutes() }
                            </div>
                            <span className="sale-banner-time-unit">
                                { getMessage(words, 'com.s7.sale.banner.timer.minute') }
                            </span>
                        </div>
                        <div className="sale-banner-time-item">
                            <div
                                className="sale-banner-time__second"
                            >
                                { currentTime.getSeconds() }
                            </div>
                            <span className="sale-banner-time-unit">
                                { getMessage(words, 'com.s7.sale.banner.timer.second') }
                            </span>
                        </div>
                    </div>
                        :
                    null
                }
                <h3 className="sale-banner-title">
                    {title}
                </h3>
            </div>
        );
    };

    return(
        <>
        {/*<div className='sale-banner'*/}
            {/*style={{*/}
                {/*backgroundColor: bgColor*/}
            {/*}}*/}
        {/*>*/}
            { (!!videoBannerDesktop || !!videoBannerMobile) &&
                <VideoBanner
                    videoBannerDesktop={videoBannerDesktop}
                    videoBannerMobile={videoBannerMobile}
                    videoDesktopLink={videoDesktopLink}
                    videoMobileLink={videoMobileLink}
                    videoBannerDesktopOverlay={videoBannerDesktopOverlay}
                    videoBannerMobileOverlay={videoBannerMobileOverlay}
                    isFirstMount={isFirstMount}
                />
            }
            <img className={
                    classNames({
                        'sale-banner__b-image': true,
                        'sale-banner-animate': true,
                        'sale-banner-image-loaded': blurImgIsLoad
                    })
                }
                src={blurImage}
                 onLoad={() => {
                     setBlurImgIsLoad(true)
                 }}
            />
            <img className={
                classNames({
                    'sale-banner__f-image': true,
                    'sale-banner-animate-reverse': true,
                    'sale-banner-image-loaded': focusImgIsLoad
                })
            }
                src={focusImage}
                 onLoad={() => {
                     setFocusImgIsLoad(true)
                 }}
            />
            {
                renderContent()
            }
        {/*</div>*/}
    </>
    );
};

export default injectIntl(connect(mapStateToProps) (React.memo(SaleBanner)));
